module.exports = "https://r.nearpod.com/assets/media/image/ic_student_paced-04f4c6b958e64316d4f966cfada1207e.svg";